export type UnavailableKind = 'missing' | 'error'

/** HTTP status of an axios/SDK failure, if there is one. */
export const httpStatusOf = (err: unknown): number | undefined =>
  (err as { response?: { status?: number } })?.response?.status ?? (err as { status?: number })?.status

/**
 * 404 (and, by default, 403) means the item is gone, never existed or belongs to another community;
 * anything else is a load failure worth retrying. Pass `forbiddenIsMissing: false` where a 403 means
 * "no access" and the page keeps its own restricted message.
 */
export const unavailableKindOf = (err: unknown, { forbiddenIsMissing = true } = {}): UnavailableKind => {
  const status = httpStatusOf(err)
  return status === 404 || (forbiddenIsMissing && status === 403) ? 'missing' : 'error'
}
